// index.ts
import colors from './colors';
import text from './text';

const GobalTheme = {   
	colors,
	text,
};
export default GobalTheme;
